'use client';

import React__default from 'react';
import { colors } from '../Utils/constants.js';

var TrustedIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.primaryColor : _b, _c = _a.size, size = _c === void 0 ? 20 : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.title, title = _e === void 0 ? '' : _e;
    return (React__default.createElement("svg", { width: size, height: size, className: className, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("circle", { cx: 10, cy: 10, r: 10, fill: color }),
        React__default.createElement("path", { d: 'm10 3 1.572 4.837h5.085l-4.114 2.99 1.572 4.836L10 12.673l-4.114 2.99 1.571-4.837-4.114-2.99h5.085L10 3Z', fill: '#fff' }),
        React__default.createElement("title", null, title)));
};

export { TrustedIcon as default };
//# sourceMappingURL=trusted-icon.js.map
